import {
  COMPILATION_SUCCESS,
  COMPILATION_ERROR,
  RUNTIME_ERROR,
  CLEAR_RESULT,
} from "../actions/types";

const initialState = {
  result: null,
  // errors: {},
  loading: true,
};

export default function (state = initialState, action) {
  const { payload, type } = action;

  switch (type) {
    case COMPILATION_SUCCESS:
      return {
        ...state,
        result: payload,
        loading: false,
      };
    case COMPILATION_ERROR:
    case RUNTIME_ERROR:
      return {
        ...state,
        result: payload,
        loading: false,
      };
    case CLEAR_RESULT:
      return {
        ...state,
        result: null,
        loading: false,
      };
    default:
      return state;
  }
}
